var _circle, _path, _path2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBlockIc = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "#D7000D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 2.25C5.71981 2.25 2.25 5.71978 2.25 10C2.25 14.2802 5.71981 17.75 10 17.75C14.2802 17.75 17.75 14.2802 17.75 10C17.75 5.71981 14.2802 2.25 10 2.25ZM14.0661 5.93414C16.1113 7.97939 16.2536 11.1054 14.7122 13.2978L6.7024 5.28801C8.89628 3.74564 12.022 3.89005 14.0661 5.93414ZM5.28799 6.70219C3.74665 8.89457 3.8889 12.0206 5.93415 14.0659C7.97827 16.11 11.104 16.2544 13.2978 14.712L5.28799 6.70219Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_18672_8398",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 16,
    height: 16
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 2.25C5.71981 2.25 2.25 5.71978 2.25 10C2.25 14.2802 5.71981 17.75 10 17.75C14.2802 17.75 17.75 14.2802 17.75 10C17.75 5.71981 14.2802 2.25 10 2.25ZM14.0661 5.93414C16.1113 7.97939 16.2536 11.1054 14.7122 13.2978L6.7024 5.28801C8.89628 3.74564 12.022 3.89005 14.0661 5.93414ZM5.28799 6.70219C3.74665 8.89457 3.8889 12.0206 5.93415 14.0659C7.97827 16.11 11.104 16.2544 13.2978 14.712L5.28799 6.70219Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_18672_8398)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 16,
    height: 16,
    fill: "white"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBlockIc);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/block_ic.6948649c485b74d2e7d009bb17000410.svg";